import { intercomSendData, intercomTrackEvent } from './intercomHelper'

export default function sendAddressToIntercom(location, deliveryZoneName) {
  // Update user or visitor search data on Intercom
  const searchedZone = {
    'TLT - Last searched city': location.city,
    'TLT - Last searched address': location.street_name,
    'TLT - Last searched delivery zone': deliveryZoneName
  };

  intercomSendData(searchedZone);
  intercomTrackEvent('covered_address_search', searchedZone);
}
